(function () {
  'use strict';

  var STORAGE_KEY = 'ylj:wishlist';
  var TOAST_SHOWN_KEY = 'ylj:wishlist-toast-shown';

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable - fail silently */
    }
  }

  function isSaved(handle) {
    return getWishlist().indexOf(handle) !== -1;
  }

  function dispatchUpdated(list) {
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { handles: list } })
    );
  }

  function toggle(handle) {
    var list = getWishlist();
    var index = list.indexOf(handle);
    var added;
    if (index === -1) {
      list.push(handle);
      added = true;
    } else {
      list.splice(index, 1);
      added = false;
    }
    saveWishlist(list);
    updateAllButtons();
    updateCountBubble();
    refreshAllContainers();
    dispatchUpdated(list);
    return added;
  }

  function remove(handle) {
    var list = getWishlist().filter(function (h) {
      return h !== handle;
    });
    saveWishlist(list);
    updateAllButtons();
    updateCountBubble();
    refreshAllContainers();
    dispatchUpdated(list);
  }

  function updateAllButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-button]');
    buttons.forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      var saved = isSaved(handle);
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
  }

  function updateCountBubble() {
    var count = getWishlist().length;
    var bubbles = document.querySelectorAll('[data-wishlist-count-bubble]');
    bubbles.forEach(function (bubble) {
      var numberEl = bubble.querySelector('[data-wishlist-count-number]');
      if (numberEl) {
        numberEl.textContent = count < 100 ? String(count) : '99+';
      }
      bubble.classList.toggle('is-wishlist-empty', count === 0);
    });
  }

  function formatMoney(cents, format) {
    var amount = (parseInt(cents, 10) || 0) / 100;
    var value = amount.toFixed(2);
    var placeholder = /\{\{\s*amount\s*\}\}/;
    if (format && placeholder.test(format)) {
      return format.replace(placeholder, value);
    }
    return '£' + value;
  }

  function showNotification(type, message, target) {
    if (!message) return;
    try {
      if (window.FoxTheme && window.FoxTheme.Notification) {
        window.FoxTheme.Notification.show({
          target: target || document.body,
          method: 'appendChild',
          type: type,
          message: message,
          last: 4500,
          sticky: false,
        });
      }
    } catch (e) {
      /* notification helper unavailable - fail silently */
    }
  }

  function isCustomerLoggedIn() {
    return (
      document.body &&
      document.body.getAttribute('data-customer-logged-in') === 'true'
    );
  }

  function maybeShowAccountToast() {
    if (isCustomerLoggedIn()) return;
    try {
      if (window.localStorage.getItem(TOAST_SHOWN_KEY) === '1') return;
      window.localStorage.setItem(TOAST_SHOWN_KEY, '1');
    } catch (e) {
      return;
    }
    // Target the open wishlist drawer (when present) rather than document.body:
    // the drawer overlay sits above page-level content, so a body-level toast
    // can end up rendered behind it and go unseen. Falls back to document.body
    // for contexts where the drawer isn't the trigger (e.g. the standalone
    // wishlist page).
    var drawer = document.querySelector('#Drawer-Wishlist');
    var drawerBody = drawer && drawer.querySelector('.wishlist-drawer__body');
    showNotification(
      'success',
      'Saved to your wishlist. Create an account to keep it safe and shop it anywhere.',
      drawerBody || drawer || document.body
    );
  }

  function spinnerSvgMarkup() {
    return (
      '<svg aria-hidden="true" focusable="false" class="f-icon-svg f-icon-svg--small f-spinner-icon" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
      '<circle fill="none" stroke-width="4" cx="33" cy="33" r="28"></circle>' +
      '</svg>'
    );
  }

  function addToCart(variantId, button) {
    if (!variantId) return;

    var FoxThemeSettings = window.FoxThemeSettings || {};
    var routes = FoxThemeSettings.routes || {};
    var addUrl = routes.cart_add_url || '/cart/add.js';

    if (button) {
      button.classList.add('btn--loading');
      button.setAttribute('aria-disabled', 'true');
    }

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);

    fetch(addUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: body,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          showNotification(
            'warning',
            response.description || response.message
          );
          return;
        }

        var cartSettings = FoxThemeSettings.cart || {};
        var willOpenDrawer =
          cartSettings.openDrawerWhenAdded &&
          cartSettings.cartType !== 'page';

        if (willOpenDrawer) {
          var wishlistDrawer = document.querySelector('#Drawer-Wishlist');
          if (
            wishlistDrawer &&
            typeof wishlistDrawer.closeDrawer === 'function'
          ) {
            wishlistDrawer.closeDrawer();
          }
        } else {
          var strings = window.FoxThemeStrings || {};
          showNotification('success', strings.item_added || 'Item added to your cart');
        }

        try {
          if (
            window.FoxThemeEvents &&
            typeof PUB_SUB_EVENTS !== 'undefined'
          ) {
            window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);
          }
        } catch (e) {
          /* pub/sub not available - fail silently */
        }
      })
      .catch(function (e) {
        console.error(e);
      })
      .finally(function () {
        if (button) {
          button.classList.remove('btn--loading');
          button.removeAttribute('aria-disabled');
        }
      });
  }

  function buildCardActions(product) {
    var actions = document.createElement('div');
    actions.className = 'wishlist-card__actions';

    var variants = product.variants || [];

    if (variants.length === 1 && variants[0].available) {
      var addButton = document.createElement('button');
      addButton.type = 'button';
      addButton.className = 'btn btn--primary btn--small wishlist-card__add';

      var label = document.createElement('span');
      label.textContent = 'Add to cart';
      addButton.appendChild(label);
      addButton.insertAdjacentHTML('beforeend', spinnerSvgMarkup());

      addButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (addButton.classList.contains('btn--loading')) return;
        addToCart(variants[0].id, addButton);
      });
      actions.appendChild(addButton);
    } else if (variants.length === 1 && !variants[0].available) {
      var soldOutButton = document.createElement('button');
      soldOutButton.type = 'button';
      soldOutButton.className =
        'btn btn--secondary btn--small wishlist-card__add';
      soldOutButton.disabled = true;
      soldOutButton.textContent = 'Sold out';
      actions.appendChild(soldOutButton);
    } else {
      var viewLink = document.createElement('a');
      viewLink.href = product.url;
      viewLink.className =
        'btn btn--secondary btn--small wishlist-card__add';
      viewLink.textContent = product.available
        ? 'Select options'
        : 'Sold out';
      actions.appendChild(viewLink);
    }

    return actions;
  }

  function buildCard(product, moneyFormat) {
    var image =
      product.featured_image || (product.images && product.images[0]) || null;
    var variant = (product.variants && product.variants[0]) || {
      price: 0,
      compare_at_price: null,
    };
    var price = formatMoney(variant.price, moneyFormat);
    var compareAt =
      variant.compare_at_price && variant.compare_at_price > variant.price
        ? formatMoney(variant.compare_at_price, moneyFormat)
        : null;

    var card = document.createElement('li');
    card.className = 'wishlist-card';
    card.setAttribute('data-wishlist-card', product.handle);

    var imageWrapper = document.createElement('a');
    imageWrapper.href = product.url;
    imageWrapper.className = 'wishlist-card__image-wrapper';
    if (image) {
      var img = document.createElement('img');
      img.src = image;
      img.alt = product.title;
      img.loading = 'lazy';
      imageWrapper.appendChild(img);
    }
    card.appendChild(imageWrapper);

    var removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className = 'wishlist-card__remove';
    removeButton.setAttribute('aria-label', 'Remove from wishlist');
    removeButton.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>';
    removeButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      remove(product.handle);
    });
    card.appendChild(removeButton);

    var info = document.createElement('div');
    info.className = 'wishlist-card__info';

    var title = document.createElement('h3');
    title.className = 'wishlist-card__title';
    var titleLink = document.createElement('a');
    titleLink.href = product.url;
    titleLink.textContent = product.title;
    title.appendChild(titleLink);
    info.appendChild(title);

    var priceEl = document.createElement('div');
    priceEl.className = 'wishlist-card__price';
    if (compareAt) {
      var s = document.createElement('s');
      s.textContent = compareAt;
      priceEl.appendChild(s);
    }
    priceEl.appendChild(document.createTextNode(price));
    info.appendChild(priceEl);

    card.appendChild(info);
    card.appendChild(buildCardActions(product));

    return card;
  }

  var containerReloaders = [];

  function initContainer(container) {
    var grid = container.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var loading = container.querySelector('[data-wishlist-loading]');
    var empty = container.querySelector('[data-wishlist-empty]');
    var moneyFormat = grid.getAttribute('data-money-format') || '';

    function renderEmptyStateIfNeeded() {
      var hasCards = grid.children.length > 0;
      grid.hidden = !hasCards;
      if (empty) empty.hidden = hasCards;
    }

    function load() {
      grid.innerHTML = '';
      var handles = getWishlist();

      if (handles.length === 0) {
        if (loading) loading.hidden = true;
        renderEmptyStateIfNeeded();
        return;
      }

      if (loading) loading.hidden = false;
      if (empty) empty.hidden = true;

      var pending = handles.length;

      handles.forEach(function (handle) {
        fetch('/products/' + handle + '.js')
          .then(function (response) {
            if (!response.ok) throw new Error('not found');
            return response.json();
          })
          .then(function (product) {
            grid.appendChild(buildCard(product, moneyFormat));
          })
          .catch(function () {
            /* product may have been removed or unpublished - drop it silently */
            remove(handle);
          })
          .finally(function () {
            pending -= 1;
            if (pending === 0) {
              if (loading) loading.hidden = true;
              renderEmptyStateIfNeeded();
            }
          });
      });
    }

    load();
    containerReloaders.push(load);
  }

  function refreshAllContainers() {
    containerReloaders.forEach(function (reload) {
      reload();
    });
  }

  function initContainers() {
    document
      .querySelectorAll('[data-wishlist-container]')
      .forEach(initContainer);
  }

  function openWishlistDrawer(opener) {
    var drawer = document.querySelector('#Drawer-Wishlist');
    if (drawer && typeof drawer.openDrawer === 'function') {
      drawer.openDrawer(opener);
    }
  }

  function initButtons() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-wishlist-button]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      var handle = button.getAttribute('data-product-handle');
      if (!handle) return;
      var added = toggle(handle);
      if (added) {
        openWishlistDrawer(button);
        maybeShowAccountToast();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateAllButtons();
    updateCountBubble();
    initContainers();
  });

  initButtons();
})();
